import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormBase } from '../../../interface/form-base';
import { BcArrayFieldProps } from '../../../interface/props/bcarrayfields';
import { BCArrayFieldsCont, BCButton, BCFieldItem, BCFieldsCont, BCFieldsDelCont, BCFieldset } from '../../../styled/global.styled';
import BcIcon from '../../Bc-Icon/Bc-icon';
import SwitchFields from '../../Bc-SwitchFields/Bc-SwitchFields';
import OptionsArrayField from './Bc-OptionsArray/Bc-OptionsArray';

let itemOptions: string;
const ArrayField = ({ setValue, field, getValues, registerArray, isRequired, unregister }: BcArrayFieldProps) => {

     /** Estado de fields */
     const [fields, setFields] = useState<any[]>([]);

     const [indexField, setIndexField] = useState<number>(0);

    const {
        register,
        resetField,
        handleSubmit,
        watch,
        formState: { isValid },
      } = useForm<any>({ mode: 'onChange' });
      const onSubmit = handleSubmit(async (data) => {
        console.log("data array fields ---->",data)
        const addField = await data;
        const fieldSuccess: FormBase = {
          item: addField.item,
          label: addField.label,
          type: addField.type,
          options: getValues('options'),
          isRequired: true
        } 
        unregister('options');
        const newFields = [...fields];
        newFields.push(fieldSuccess);
        setFields(newFields);
        setValue(field.item, newFields);
        field?.arrayFields?.forEach(async (field: FormBase) => {
            resetField(field.item);
        });
      });

/** Metodo de agregar fields */
  const addFields = () => {
    onSubmit();
  }

  const deleteField = (fieldDelete: number) => {
    const updateFields = [...fields];
    updateFields.splice(fieldDelete, 1);
    setFields(updateFields);
    setValue(field.item, updateFields);
  }

  const optionsField: FormBase = {
    item: 'options',
    label: 'Opciones',
    isRequired: true,
    type: 'hidden'
  }


    return(
        <BCArrayFieldsCont>
          <BCFieldset>
              <legend>{field.label}</legend>
              {field?.arrayFields && field?.arrayFields.map((fieldArray: FormBase) => {
                const watchField = watch(fieldArray.item);
                return(
                  <div key={`array${fieldArray.item}`}>
                    <SwitchFields field={fieldArray} register={register} setValue={setValue} isRequired={isRequired} watch={watch} unregister={unregister}  />
                    {(watchField === 'select' || watchField === 'multi_select') ? <OptionsArrayField field={optionsField} setValue={setValue} getValues={getValues} /> : null}
                  </div>
              )})}
          </BCFieldset>
          <input type="hidden" {...registerArray(field.item, { required: isRequired })} />
          <BCButton type="button" className="bc-button-primary bc-button-small" disabled={!isValid} onClick={() => addFields()} >Agregar {field.label}</BCButton>
          <BCFieldsCont>
            {fields.length > 0 ?
              fields.map((itemsField: any, index: number) => (
                <BCFieldItem key={`create${itemsField.item}`}>
                  <div>
                    <h5>Datos a guardar</h5>
                    {itemsField && Object.keys(itemsField).map((itemValue: string) => (
                      <span key={`item${itemValue}`}>{itemValue && <p>
                      <strong>{`${itemValue}:`}</strong> { itemValue === 'options' ? `${JSON.stringify(itemsField[itemValue])}` : `${itemsField[itemValue]}`}
                    </p>}</span>
                    ))}
                  </div>
                  <BCFieldsDelCont>
                    <BCButton type="button" className="bc-button-primary bc-button-small" onClick={() => deleteField(index)}> 
                      <BcIcon iconName="error" />
                    </BCButton>
                  </BCFieldsDelCont>
                </BCFieldItem>
              ))
              :
              <h4>Sin {field.item} agregados</h4>}
          </BCFieldsCont>
        </BCArrayFieldsCont>
    )
}

export default ArrayField;